// shortcut: whole stars only, rounded down like the rating text (2.5 shows 2). Use a partial fill when the design needs exact ratings.
export const filledStars = (rating: number | null) =>
  rating === null ? 0 : Math.floor(Math.min(Math.max(rating, 0), 5));
